(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play/assets/javascripts/fetch-video-analyses.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play/assets/javascripts/fetch-video-analyses.js');
"use strict";


const useVideoAnalyses = svs.components.tipsen.hooks.useVideoAnalyses;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const VideoAnalysisPlayer = svs.components.tipsen.videoAnalysisPlayer.VideoAnalysisPlayer;

const FetchVideoAnalyses = () => {
  const isMobile = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const currentDraw = useCurrentDraw();
  const currentDrawNumber = currentDraw ? currentDraw.drawNumber : null;
  useVideoAnalyses({
    drawNumber: currentDrawNumber,
    autoFetch: Boolean(currentDrawNumber),
    categories: 'stryktipspodden'
  });
  if (!isMobile) {
    return null;
  }

  return React.createElement("div", {
    className: "pg_route_play__video_analysis_player--floating"
  }, React.createElement(VideoAnalysisPlayer, null));
};
setGlobal('svs.components.tipsen.routePlay.FetchVideoAnalyses', FetchVideoAnalyses);

 })(window);